<template lang="pug">
form(@submit.prevent="submit" name="speaker-form" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body.modal-tabs
      b-tabs(
        v-model="activeTab"
        position="is-centered"
        expanded
      )
        b-tab-item(label="Details")
          b-field(grouped)
            b-field(label="Category")
              b-select(
                :value="speaker.category"
                @input="set($event, 'category')"
              )
                option(value="guest") Guest
                option(value="staff") Staff
            b-field(
              v-if="speaker.category === 'staff'"
              label="Title"
              expanded
            )
              b-input(
                :value="speaker.title"
                @input="set($event, 'title')"
              )
          b-field(label="Full Name")
            b-input(
              :value="speaker.full_name"
              @input="set($event, 'full_name')"
            )
          b-field(label="Biography")
            b-input(
              type="textarea"
              rows="3"
              :value="speaker.bio"
              @input="set($event, 'bio')"
            )
        b-tab-item(label="Profile Image")
          cover-art-tab(
            v-model="profileImage"
            :default-image="defaultProfileImage"
            :height="293"
            :width="293"
            @input="img => profileImage = img"
          )
        b-tab-item(label="Header Image")
          cover-art-tab(
            v-model="headerImage"
            :default-image="defaultHeaderImage"
            @input="img => headerImage = img"
          )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) {{ saveBtnLabel }}
</template>

<script>
import { mapGetters } from 'vuex';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'speaker-form',
  components: {
    CoverArtTab,
  },
  computed: {
    ...mapGetters({
      speaker: getters.GET_SPEAKER,
    }),
    defaultHeaderImage() {
      if (this.speaker._embedded.header_image.id) {
        return this.speaker._embedded.header_image.file.url;
      }
      return null;
    },
    defaultProfileImage() {
      if (this.speaker._embedded.profile_image.id) {
        return this.speaker._embedded.profile_image.file.url;
      }
      return null;
    },
    isNew() {
      return this.speaker.id === undefined;
    },
    saveBtnLabel() {
      return this.isNew ? 'Save Speaker' : 'Save Changes';
    },
    title() {
      return this.isNew ? 'New Speaker' : `Edit Speaker: ${this.speaker.full_name}`;
    },
  },
  data() {
    return {
      activeTab: 0,
      headerImage: null,
      profileImage: null,
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_SPEAKER_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      this.settings.submitting = true;
      const action = this.isNew ? actions.DO_CREATE_SPEAKER : actions.DO_UPDATE_SPEAKER;
      const payload = {
        id: this.speaker.id,
        bio: this.speaker.bio,
        category: this.speaker.category,
        full_name: this.speaker.full_name,
        title: this.speaker.title,
        zoom: 'header_image,profile_image',
      };
      if (this.headerImage) {
        const file = this.headerImage.generateDataUrl('image/jpeg');
        const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
        payload.header_image_id = data.images[0].id;
      }
      if (this.profileImage) {
        const file = this.profileImage.generateDataUrl('image/jpeg');
        const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
        payload.profile_image_id = data.images[0].id;
      }
      const response = await this.$store.dispatch(action, payload);
      this.$parent.close();
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: response.message,
      });
      setTimeout(() => {
        this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/SpeakerForm.vue